import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/content";

export default function Testimonials() {
  return (
    <section id="velemenyek" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl mb-14">
          <span className="text-xs sm:text-sm uppercase tracking-widest font-bold text-sky-600 bg-sky-50 px-3 py-1 rounded-full inline-block mb-4 border border-sky-100">
            Vélemények
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900">
            Amit az ügyfelek <span className="text-sky-600">mondanak.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="relative rounded-2xl border border-slate-200 bg-slate-50/60 p-7 hover:shadow-xl hover:shadow-slate-100 transition-shadow"
            >
              <Quote className="w-9 h-9 text-sky-200 mb-4" />
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="w-4 h-4 fill-amber-400 text-amber-400" />
                ))}
              </div>
              <p className="text-slate-700 leading-relaxed">{t.text}</p>
              <div className="mt-6 pt-5 border-t border-slate-200 flex items-center gap-3">
                <div className="w-11 h-11 rounded-full bg-sky-600 text-white flex items-center justify-center font-display font-bold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="font-bold text-slate-900 text-sm">{t.name}</div>
                  <div className="text-xs text-slate-500">{t.place} · {t.job}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
